module.exports = __webpack_public_path__ + "img/003.64693df4.png";